module.exports = __webpack_public_path__ + "static/media/APPLY.b8505f10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/APPLY.svg
// module id = 1445
// module chunks = 0